import BinaryHeap from "./binaryHeap";
import findNeighborsId from "./findNeightborsId";
import distanceCalculator from './distanceCalculator';
import matrixBuilder, { allNodesInfo } from 'utils/matrixBuilder';

function getHeap() {
  return new BinaryHeap(function (node) {
    return node.f;
  });
};

function pathTo(node, start) {
  var curr = node;
  var path = [];
  while (curr.parent) {
    path.unshift(curr);
    curr = curr.parent;
  }
  path.unshift(start);
  return path;
};

function calculateAllHCosts (allNodesInfo, endNode) {
  const newAllNodesInfo = allNodesInfo.map(ele => {
    ele.h = distanceCalculator(ele, endNode);
    return ele;
  });
  return newAllNodesInfo;
}

export default function searchPath (mapMatrix, nodesInfoInput, startId, endId) {
  
  const start = nodesInfoInput.find(item => item.id === +startId);
  const end = nodesInfoInput.find(item => item.id === +endId);
  const nodesStatus = calculateAllHCosts(nodesInfoInput, end);
  var openHeap = getHeap();
  var closestNode = start;
  start.g = 0;

  openHeap.push(start);

  while (openHeap.size() > 0) {

    var currentNode = openHeap.pop();
    var currentId = currentNode.id;

    if (currentId === end.id) {
      return pathTo(currentNode, start);
    }
    currentNode.closed = true;

    var neighbors = findNeighborsId(mapMatrix, currentId);
    for (var i = 0, il = neighbors.length; i < il; ++i) {
      var neighborId = neighbors[i];
      var neighbor = nodesStatus.find(ele => ele.id === neighborId);

      if (neighbor.closed) {
        continue;
      }

      // The g score is the shortest distance from start to current node.
      // We need to check if the path we have arrived at this neighbor is the shortest one we have seen yet.
      var gScore = currentNode.g + mapMatrix[`${currentId}`][`${neighborId}`];
      var beenVisited = neighbor.visited;

      if (!beenVisited || gScore < neighbor.g) {

        // Found an optimal (so far) path to this node.  Take score for node to see how good it is.
        neighbor.visited = true;
        neighbor.parent = currentNode;
        // neighbor.h = vertexDistanceCalculator(...findDualDomNodes(neighborId, end));
        neighbor.g = gScore;
        neighbor.f = neighbor.g + neighbor.h;

        if (neighbor.h < closestNode.h || (neighbor.h === closestNode.h && neighbor.g < closestNode.g)) {
          closestNode = neighbor;
        }


        if (!beenVisited) {
          // Pushing to heap will put it in proper place based on the 'f' value.
          openHeap.push(neighbor);
        } else {
          // Already seen the node, but since it has been rescored we need to reorder it in the heap
          openHeap.rescoreElement(neighbor);
        }
      }
    }
  };
  return pathTo(closestNode, start);
};

/**
 *  To aid finding the nearest destination amongst options
 * @param {array} path 
 */
export const calculateGCostOfPath = (path) => {
  return path.reduce((acc, item) => (acc + item.g), 0);
};

export function setupAndSearch (connections, vertices, startSvgId, endSvgId) {
  if (
    (startSvgId + endSvgId) > 0
    && (connections?.length && vertices?.length)
    && startSvgId !== null && endSvgId !== null
  ) {
    const matrix = matrixBuilder(connections, vertices.length);
    const allNodesStatus = allNodesInfo(vertices);
    const path = searchPath(matrix, allNodesStatus, startSvgId, endSvgId);
    return path;
  }
  return [];
};